import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface ShortcutsHelpProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

// Grouped for the overlay. `keys` render as individual <kbd> chips.
const GROUPS: { heading: string; rows: { keys: string[]; label: string }[] }[] = [
  {
    heading: 'Actions',
    rows: [
      { keys: ['/'], label: 'Search — open the command palette' },
      { keys: ['n'], label: 'New — quick capture a note or task' },
      { keys: ['?'], label: 'Show this help' },
    ],
  },
  {
    heading: 'Go to',
    rows: [
      { keys: ['g', 't'], label: 'Today' },
      { keys: ['g', 'i'], label: 'Inbox' },
      { keys: ['g', 'p'], label: 'Pipeline' },
      { keys: ['g', 'c'], label: 'Contacts' },
      { keys: ['g', 'k'], label: 'Tasks' },
      { keys: ['g', 'l'], label: 'Calendar' },
      { keys: ['g', 'd'], label: 'Projects' },
      { keys: ['g', 'r'], label: 'Reports' },
      { keys: ['g', 'f'], label: 'Finance' },
    ],
  },
  {
    heading: 'With ⌘ / Ctrl',
    rows: [
      { keys: ['⌘', 'K'], label: 'Command palette' },
      { keys: ['⌘', 'J'], label: 'Chat with Friday' },
      { keys: ['⌘', 'N'], label: 'Quick capture' },
    ],
  },
]

function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="inline-flex min-w-[1.5rem] items-center justify-center rounded border border-border bg-muted px-1.5 py-0.5 text-xs font-medium text-foreground">
      {children}
    </kbd>
  )
}

export function ShortcutsHelp({ open, onOpenChange }: ShortcutsHelpProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {GROUPS.map((group) => (
            <div key={group.heading}>
              <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                {group.heading}
              </p>
              <div className="space-y-1.5">
                {group.rows.map((row) => (
                  <div key={row.label} className="flex items-center justify-between gap-4">
                    <span className="text-sm text-foreground">{row.label}</span>
                    <span className="flex items-center gap-1">
                      {row.keys.map((k, i) => (
                        <span key={i} className="flex items-center gap-1">
                          {i > 0 && group.heading === 'Go to' && (
                            <span className="text-xs text-muted-foreground">then</span>
                          )}
                          <Kbd>{k}</Kbd>
                        </span>
                      ))}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
